import React from 'react';
import { PaymentMethod } from '../../../../models';

interface PaymentMethodOptionProps {
  paymentMethod: PaymentMethod;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function PaymentMethodOption({
  paymentMethod,
  checked,
  onChange,
}: PaymentMethodOptionProps) {
  return (
    <div className="p-3 border border-neutral-300 rounded relative z-50">
      <div className="flex w-auto  items-center ml-1">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className="w-4 h-4 mt-1 cursor-pointer bg-white rounded border-purple-200 focus:ring-purple-300 focus:ring-2 "
          data-id={paymentMethod?._id}
        />
        <label className="ml-4 text-text-black mt-1 font-arial font-semibold">
          {paymentMethod.title}
        </label>
      </div>
    </div>
  );
}

export default PaymentMethodOption;
